import Item from '../Result.Grid.i18n';
import custom from '@/f1/custom';
import codes from '@/f1/codes';
import DatePicker from 'vue2-datepicker';
import { api  } from '@/f1/service';
import moment from 'moment-timezone'
import { Switch as cSwitch } from '@coreui/vue';
import { VclFacebook } from 'vue-content-loading';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import _ from 'lodash'

//restful api
//import { wmds as ws } from '@/f1/service/api'

//i18n_data
// import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  props : ['view_only', 'max', 'show_title'],
  components: { cSwitch, DatePicker, Item, VclFacebook, Autocomplete },
  data: () => {
    return {
      load_count : 0,
      loading : true,
      currentPage : 1,
      so : Object.assign({}, codes.DEFAULT_OPT, { perPage : 10 }),
      codes,
      item : undefined,
      custom,
      model : [],
      fqdn_list : [] // fqdn 목록
    }
  },
  watch : {
    currentPage() { this.load() }
  },
  computed: {
    getRowCount () { return this.so.totalRows || 0; },
  },
  methods: {
    update() {
      // custom
      let index = _.indexOf(this.fqdn_list, this.so.sv)
      if (_.indexOf(this.fqdn_list, this.so.sv) > -1) {
        this.so.sv = this.fqdn_list[index]
        // console.log(`Selected: ${results[selectedIndex]}`)
      } else { this.so.sv = ''; }
    },
    getResultValue(result) {
      console.log("getresultvalue", result)
      this.so.sv = result
      return result
    },
    onSubmit(result) {
      if(this.so.sv.length < 1 || !result)  { this.so.sv = ''; }
      console.info(this.so.sv, "Submit", this.so.sk);
      this.load();
      this.$emit('refresh')
    },
    typing(input, count = 10) {
      try {
        if(this.so.sk != 'fqdn') { this.so.sk = 'fqdn' }
        this.so.sv = input
        let rs = _.filter(this.fqdn_list, r => r.toLowerCase().startsWith(input.toLowerCase()))
        // console.log('rs', (rs || []).slice(0, count))
        if(rs.length > count) { let list = (rs || []).slice(0, count); list.push('... more ' + Number(rs.length - count)); return list  }
        return rs
      } catch (e) { console.error('typing error', e) }
    },
    select(item) {
      this.item = item;
      this.detail = true;
      console.log("change to", item.fqdn)
      this.$router.push({ name : 'wmds_result', params : { site_id : item.id } })
      // console.log(item)
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k.endsWith('_count')) {
        return { name : k, value : 0, op :  v == true ? '>' : '<=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.refresh(); },
    refresh() { this.load(); },
    load(ctx = {}) {
      if(this.loading) {
        return this.loading = false
      }
      this.loading = true
        this.so.currentPage = this.currentPage
        let so = {
          target : 'site', cmd : 'info',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.so.sk && this.so.sk) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;
            // console.log("this.so.opt[k[i]])", moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), k[i].slice(0, 11), k[i] == 'finished_at_ed')

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_startTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_endTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'finished_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_startTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'finished_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_endTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        }
        // console.log('get site info!!!', so)
      return api.wmds.WMDS(so).then(rs => { this.so.totalRows = rs.total; this.$parent.$emit('loading', false); this.loading = false; this.model = rs.body ? rs.body : []; })
      //return ws.site.info(so).then(rs => { this.so.totalRows = rs.total; this.$parent.$emit('loading', false); this.loading = false; this.model = rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    load_fqdn() {
        this.so.currentPage = this.currentPage
        let so = {
          target : 'site', cmd : 'list.fqdn',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
        }
      return api.wmds.WMDS(so)
      //return ws.site.domain(so)
        .then(rs => { this.fqdn_list =  rs.body ? rs.body : [] })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail(item) { this.$router.push(`result/${item.id}`, item); },
    hideList(e) { this.show = !e; console.log('wmds.site.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') },
    clear() { this.opt = { group_id : '', group_name : '', site_fqdn : '' }; this.load(true) },
  },
  created() { console.log('wmds.site.list.vue', 'created'); },
  destroyed() { console.log('wmds.site.list.vue', 'destroyed'); },
  mounted() {
    console.log('wmds.site.list.vue', 'mounted');
    this.load();
    setTimeout(this.load_fqdn, 1000)
  },
}
